import { AutoSaveIndicator } from './AutoSaveIndicator';
import { AutoSaveProps, useAutoSave } from './useAutoSave';

export const AutoSave = (props: AutoSaveProps) => {
  const { isAutoSaving, autoSavingError, updatedAt } = useAutoSave(props);

  if (props.isButtonHidden) {
    return null;
  }

  return (
    <AutoSaveIndicator
      lastSave={updatedAt}
      error={autoSavingError ? { code: 'ERR_NETWORK' } : undefined}
      isAutoSaving={isAutoSaving}
      readonly={props.readonly}
    />
  );
};
